import { useNavigate } from 'react-router-dom';
import './Welcome.css';

function Welcome() {
  const navigate = useNavigate();

  return (
    <div className="welcome-page">
      <div className="welcome-container">
        <div className="welcome-hero">
          <img src="/mosaic-icon.png" alt="mosaime" className="welcome-logo" />
          <h1>Welcome to Mosaime!</h1>
          <p>You're all set. You should receive a text message shortly to get started.</p>
        </div>

        <div className="welcome-card">
          <div className="welcome-sms-note">
            Just reply to it like you would a friend — that's all there is to it.
          </div>

          <p className="welcome-guide-intro">
            Want to know everything Mosaime can do? Check out the user guide for a full breakdown with examples.
          </p>

          <div className="welcome-actions">
            <button onClick={() => navigate('/guide')} className="btn btn-primary">
              Review the User Guide
            </button>
          </div>

          <div className="welcome-skip">
            <button onClick={() => navigate('/settings')} className="welcome-skip-link">
              Skip to Settings
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Welcome;
